// extracted by mini-css-extract-plugin
module.exports = {"media":"CommentForm_media__3s8gA"};